module.exports = __webpack_public_path__ + "static/media/compare-illustration.ba8fbef3.svg";